import { PRODUCT_NAME } from 'src/apps/dashboard/pages/issues/types/IssuesTypes';
import { IMobileAllIssuesResult } from 'src/apps/dashboard/types/MobileDashboardServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { MobileDashboardAllIssuesQuery } from '../MobileAllIssues.generated';

const MOBILE_PRODUCT_DISPLAY_NAMES: Record<string, string> = {
	MOBILE_FLOW_ANALYZER: 'Mobile Flow Analyzer',
	MOBILE_SDK: 'Mobile SDK'
};

export const transformMobileAllIssuesResults = (
	rawResults: MobileDashboardAllIssuesQuery
): IMobileAllIssuesResult => {
	const issues =
		rawResults.issues?.filter(returnNonNull).map((issue) => ({
			id: issue.issue_id,
			runId: issue.run_id,
			productName: issue.product_name as PRODUCT_NAME,
			issueType: issue.type_name,
			severity: issue.severity_name,
			appId: issue.app_id,
			elementDescription: issue.scan_name,
			foundBy: MOBILE_PRODUCT_DISPLAY_NAMES[issue.product_name] ?? issue.product_name,
			sessionOrTest: issue.session_name,
			user: ''
		})) ?? [];

	return {
		issues,
		totalCount: rawResults.total?.[0]?.issue_id_count ?? 0,
		unfilteredTotal: rawResults.unfilteredTotal?.[0]?.issue_id_count ?? 0
	};
};
